import { Link } from "react-router-dom";

interface Crumb {
  label: string;
  to?: string;
}

export default function Breadcrumbs({ items }: { items: Crumb[] }) {
  return (
    <nav aria-label="面包屑导航" className="mb-6">
      <ol className="flex flex-wrap items-center gap-1.5 font-label text-[12px] text-foreground-500">
        <li>
          <Link to="/" className="transition-colors hover:text-primary-700">
            首页
          </Link>
        </li>
        {items.map((item) => (
          <li key={item.label} className="flex items-center gap-1.5">
            <i className="ri-arrow-right-s-line text-foreground-300" />
            {item.to ? (
              <Link to={item.to} className="transition-colors hover:text-primary-700">
                {item.label}
              </Link>
            ) : (
              <span className="max-w-[240px] truncate text-foreground-800">{item.label}</span>
            )}
          </li>
        ))}
      </ol>
    </nav>
  );
}